import { createReactComponent } from '@tabler/icons-react';

export const IconCustomExport = createReactComponent(
  'outline',
  'customExport',
  'CustomExport',
  [
    [
      'path',
      {
        key: 'customExport-path',
        d: 'M15.3,7.6V6.5c0-0.6-0.2-1.1-0.6-1.6c-0.4-0.4-1-0.6-1.6-0.6H4.3c-0.6,0-1.1,0.2-1.6,0.6S2,5.9,2,6.5v11.1c0,0.6,0.2,1.1,0.6,1.6s1,0.6,1.6,0.6h8.9c0.6,0,1.1-0.2,1.6-0.6c0.4-0.4,0.6-1,0.6-1.6v-1.1 M9.8,12H22 M22,12l-3.3-3.3 M22,12l-3.3,3.3',
      },
    ],
  ]
);
